<script setup lang="ts">
import { computed } from 'vue';
import { BFormCheckbox } from 'bootstrap-vue-next';
import type { IColumnDefinition, RowData, ICheckboxColumn } from '../types';

const props = defineProps<{
  value: any;
  row: RowData;
  column: IColumnDefinition;
}>();

const col = computed(() => props.column as ICheckboxColumn);
</script>

<template>
  <div class="d-flex justify-content-center">
    <BFormCheckbox :model-value="!!value" disabled />
  </div>
</template>
